var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionUserAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.669984 2.40531C0.287134 2.0116 0.257063 1.39452 0.59982 0.965449C1.0092 0.452978 1.77524 0.415648 2.23251 0.885889L10 8.87373L17.7675 0.885888C18.2248 0.415649 18.9908 0.452977 19.4002 0.965448C19.7429 1.39452 19.7129 2.0116 19.33 2.40531L10 12L0.669984 2.40531Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionUserAccordionArrow);
export default __webpack_public_path__ + "static/media/sessionUserAccordionArrow.80eeb074.svg";
export { ForwardRef as ReactComponent };